export class Llamado {
  paciente: string;
  medico: string;
  box: number;
  piso: number;
  id : string;
  idx: number;
}
